import { UnknownObject } from '@tulp';

import { downloadGet } from './files';

export function exportItems<T extends UnknownObject>(url: string, params: T, csvFileName: string) {
  return downloadGet(url, params, csvFileName);
}
